import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
interface StoryCardProps {
  title: string;
  excerpt: string;
  image: string;
  category: string;
  href: string;
  delay?: number;
}
export function StoryCard({
  title,
  excerpt,
  image,
  category,
  href,
  delay = 0
}: StoryCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6,
    delay
  }} className="bg-white rounded-lg overflow-hidden shadow-lg" data-id="element-116">
      <div className="h-64 bg-gray-200 overflow-hidden" data-id="element-117">
        <img src={image} alt={title} className="w-full h-full object-cover" data-id="element-118" />
      </div>
      <div className="p-6" data-id="element-119">
        <div className="text-xs font-semibold text-[var(--color-primary)] mb-2 uppercase tracking-wider" data-id="element-120">
          {category}
        </div>
        <h3 className="text-xl text-[var(--color-text)] mb-3 font-bold" data-id="element-121">
          {title}
        </h3>
        <p className="text-[var(--color-text-light)] mb-4 leading-relaxed" data-id="element-122">
          {excerpt}
        </p>
        <Button variant="outline" size="sm" href={href} data-id="element-123">
          Read More
        </Button>
      </div>
    </motion.div>;
}